import React, { /*Component, */ useState, useEffect } from "react";
import { Grid, Row, Col /*, Modal, InputGroup */ } from "react-bootstrap";
// import auth from "../../services/authService";
import * as reportService from "../../services/reportServices";
// import Input from "../../components/Common/input";
// import Datetime from "react-datetime";
import moment from "moment";
import Select from "../../components/Common/select";
// import Checkbox from "../../components/Common/checkbox";
// import Textarea from "../../components/Common/textarea";
import { Chart } from "react-charts";
import PieChart from "./pieChart";
// import firebase from "firebase";
// import "firebase/firestore";
// import "firebase/auth";

// import { useAuthState } from "react-firebase-hooks/auth";
// import { userCollectionData } from "react-firebase-hooks/firestore";

var base64 = require("base-64");

// firebase.initializeApp({
//   apiKey: "AIzaSyAIgcf9qDXvSD8OEXASBG69V6lTCBix4BY",
//   authDomain: "interbrucke-22acf.firebaseapp.com",
//   projectId: "interbrucke-22acf",
//   storageBucket: "interbrucke-22acf.appspot.com",
//   messagingSenderId: "996409697294",
//   appId: "1:996409697294:web:33b9428d3525ae57e2085f",
//   measurementId: "G-0MP8BQ50LL",
// });

// const auth = firebase.auth();
// const firestore = firebase.firestore();

// function SignIn() {
//   const signInWithGoogle = () => {
//     const provider = new firebase.auth.GoogleAuthProvider();
//     auth.signInWithPopup(provider);
//   };
//   return <button onClick={signInWithGoogle}>Sign in with Google</button>;
// }
// function SignOut() {
//   return (
//     auth.currentUser && <button onClick={() => auth.signOut()}>Sign Out</button>
//   );
// }

function PengirimanDashboard() {
  const [cbBulan, setcbBulan] = useState([
    { value: 1, label: "JAN" },
    { value: 2, label: "FEB" },
    { value: 3, label: "MAR" },
    { value: 4, label: "APR" },
    { value: 5, label: "MAY" },
    { value: 6, label: "JUN" },
    { value: 7, label: "JUL" },
    { value: 8, label: "AUG" },
    { value: 9, label: "SEP" },
    { value: 10, label: "OCT" },
    { value: 11, label: "NOV" },
    { value: 12, label: "DEC" },
  ]);
  const [cbTahun, setcbTahun] = useState([]);
  useEffect(() => {
    let fulldatetime = new Date();
    let currYear = parseInt(moment(fulldatetime, "YYYY").format("YYYY"), 10);
    if (
      cbTahun.length === 0 ||
      cbTahun[cbTahun.length - 1].value + 20 > currYear
    ) {
      setcbTahun([
        ...cbTahun,
        {
          value: parseInt(
            cbTahun[cbTahun.length - 1]
              ? cbTahun[cbTahun.length - 1].value - 1
              : currYear, //init tahun awal
            10
          ),
          label: parseInt(
            cbTahun[cbTahun.length - 1]
              ? cbTahun[cbTahun.length - 1].value - 1
              : currYear, //init tahun awal
            10
          ),
        },
      ]);
    }
  }, [cbTahun.length]);
  const [search, setSearch] = useState({
    bulan: cbBulan[parseInt(moment(new Date(), "M").format("M")) - 1].label,
    tahun: moment(new Date(), "YYYY").format("YYYY"),
  });
  useEffect(() => {
    getData();
  }, [search.bulan, search.tahun]);
  const [dataLoaded, setDataLoaded] = useState(true);
  const handleChangeSearch = ({ currentTarget: input }) => {
    const s = { ...search };
    s[input.name] = input.value;
    setSearch(s);
  };
  const getData = async () => {
    const s = { ...search };
    setDataLoaded(false);
    await reportService.getDashboardReport(s).then((data) => {
      console.log(data);
      const temp = data.sq
        ? data.sq.map((s) => {
            return [s[0], parseFloat(s[1])];
          })
        : [];
      const temp2 = data.sq2
        ? data.sq2.map((s) => {
            return [s[0], parseFloat(s[1])];
          })
        : [];
      // console.log(temp);
      const d = { ...dataOrderMasuk };
      d[1].data = temp;
      d[1].label = s.tahun;
      d[0].data = temp2;
      d[0].label = s.tahun - 1;
      d.length = 2;
      setDataOrderMasuk(d);

      const fab = data.fab
        ? data.fab.map((s) => {
            return [s[0], parseFloat(s[1])];
          })
        : [];
      const fab2 = data.fab2
        ? data.fab2.map((s) => {
            return [s[0], parseFloat(s[1])];
          })
        : [];
      // console.log(fab);
      const d2 = { ...dataOrderMasukFabrikasi };
      d2[1].data = fab;
      d2[1].label = s.tahun;
      d2[0].data = fab2;
      d2[0].label = s.tahun - 1;
      d2.length = 2;
      setDataOrderMasukFabrikasi(d2);

      const fabidr = data.fabidr
        ? data.fabidr.map((s) => {
            return [s[0], parseFloat(s[1])];
          })
        : [];
      const fabidr2 = data.fabidr2
        ? data.fabidr2.map((s) => {
            return [s[0], parseFloat(s[1])];
          })
        : [];
      // console.log(fab);
      const d3 = { ...dataOrderMasukFabrikasiIdr };
      d3[1].data = fabidr;
      d3[1].label = s.tahun;
      d3[0].data = fabidr2;
      d3[0].label = s.tahun - 1;
      d3.length = 2;
      setDataOrderMasukFabrikasiIdr(d3);

      const sqk = data.sqk
        ? data.sqk.map((s) => {
            return [s[0], parseFloat(s[1])];
          })
        : [];
      const sqk2 = data.sqk2
        ? data.sqk2.map((s) => {
            return [s[0], parseFloat(s[1])];
          })
        : [];
      // console.log(sqk);
      const d4 = { ...dataOrderKirim };
      d4[1].data = sqk;
      d4[1].label = s.tahun;
      d4[0].data = sqk2;
      d4[0].label = s.tahun - 1;
      d4.length = 2;
      setDataOrderKirim(d4);

      const fabkidr = data.fabkidr
        ? data.fabkidr.map((s) => {
            return [s[0], parseFloat(s[1])];
          })
        : [];
      const fabkidr2 = data.fabkidr2
        ? data.fabkidr2.map((s) => {
            return [s[0], parseFloat(s[1])];
          })
        : [];
      // console.log(fab);
      const d5 = { ...dataOrderKirimFabrikasiIdr };
      d5[1].data = fabkidr;
      d5[1].label = s.tahun;
      d5[0].data = fabkidr2;
      d5[0].label = s.tahun - 1;
      d5.length = 2;
      setDataOrderKirimFabrikasiIdr(d5);

      const sqs = data.sqs
        ? data.sqs.map((s) => {
            return [s[0], parseFloat(s[1])];
          })
        : [];
      const sqs2 = data.sqs2
        ? data.sqs2.map((s) => {
            return [s[0], parseFloat(s[1])];
          })
        : [];
      // console.log(fab);
      const d6 = { ...dataSisaOrder };
      d6[1].data = sqs;
      d6[1].label = s.tahun;
      d6[0].data = sqs2;
      d6[0].label = s.tahun - 1;
      d6.length = 2;
      setDataSisaOrder(d6);

      const pc = data.pie
        ? data.pie.map((s) => {
            return [s[0], parseFloat(s[1])];
          })
        : [];
      setDataPieChart(pc);
      setDataLoaded(true);
    });
  };
  const [dataOrderMasuk, setDataOrderMasuk] = useState(
    () => [
      {
        label: "",
        data: [
          ["JAN", 55184],
          ["FEB", 12312],
          ["MAR", 4312312],
          ["APR", 2342344],
          ["MAY", 56545],
          ["JUN", 63123],
          ["JUL", 5434537],
          ["AUG", 823423412],
          ["SEP", 2334329],
          ["OCT", 12345432],
          ["NOV", 1324234],
          ["DEC", 123432123],
        ],
      },
      {
        label: "",
        data: [],
      },
    ],
    []
  );

  const [dataSisaOrder, setDataSisaOrder] = useState(
    () => [
      {
        label: "",
        data: [
          ["JAN", 0],
          ["FEB", 0],
          ["MAR", 0],
          ["APR", 0],
          ["MAY", 0],
          ["JUN", 0],
          ["JUL", 0],
          ["AUG", 0],
          ["SEP", 0],
          ["OCT", 0],
          ["NOV", 0],
          ["DEC", 99999999],
        ],
      },
      {
        label: "",
        data: [],
      },
    ],
    []
  );
  const [dataOrderMasukFabrikasi, setDataOrderMasukFabrikasi] = useState(
    () => [
      {
        label: "",
        data: [
          ["Lainnya", 112306.2368],
          ["PRMF", 19545],
          ["EWF", 55184.9655],
          ["VTX", 62155.73799],
          ["PAP", 115636.4074],
          ["AAM", 197107.8648],
          ["REI AUS", 482098.0034],
          ["REI", 440033.5414],
        ],
      },
      {
        label: "",
        data: [],
      },
    ],
    []
  );
  const [dataOrderMasukFabrikasiIdr, setDataOrderMasukFabrikasiIdr] = useState(
    () => [
      {
        label: "",
        data: [
          ["Lainnya", 112306.2368],
          ["PRMF", 19545],
          ["EWF", 55184.9655],
          ["VTX", 62155.73799],
          ["PAP", 115636.4074],
          ["AAM", 197107.8648],
          ["REI AUS", 482098.0034],
          ["REI", 999999999999999.5414],
        ],
      },
      {
        label: "",
        data: [],
      },
    ],
    []
  );
  const [dataOrderKirim, setDataOrderKirim] = useState(
    () => [
      {
        label: "",
        data: [
          ["Lainnya", 112306.2368],
          ["PRMF", 19545],
          ["EWF", 55184.9655],
          ["VTX", 62155.73799],
          ["PAP", 115636.4074],
          ["AAM", 197107.8648],
          ["REI AUS", 482098.0034],
          ["REI", 999999999999999.5414],
        ],
      },
      {
        label: "",
        data: [],
      },
    ],
    []
  );
  const [dataOrderKirimFabrikasiIdr, setDataOrderKirimFabrikasiIdr] = useState(
    () => [
      {
        label: "",
        data: [
          ["Lainnya", 112306.2368],
          ["PRMF", 19545],
          ["EWF", 55184.9655],
          ["VTX", 62155.73799],
          ["PAP", 115636.4074],
          ["AAM", 197107.8648],
          ["REI AUS", 482098.0034],
          ["REI", 999999999999999.5414],
        ],
      },
      {
        label: "",
        data: [],
      },
    ],
    []
  );

  const [dataPieChart, setDataPieChart] = useState(() => [
    [
      ["MF", 1808482.901],
      ["NA", 873129.5504],
      ["PC", 1667486.13],
      ["BR", 28012.2772],
      ["GA", 32947.1778],
      ["Polished", 72382.34916],
      ["SNA", 15886.369],
    ],
  ]);
  useEffect(() => {
    // console.log(dataPieChart);
  });
  const seriesBar = React.useMemo(
    () => ({
      type: "bar",
    }),
    []
  );
  const axesBar = React.useMemo(
    () => [
      { primary: true, type: "ordinal", position: "left" },
      { position: "bottom", type: "linear", stacked: false },
    ],
    []
  );
  const axesColumn = React.useMemo(
    () => [
      { primary: true, type: "ordinal", position: "bottom" },
      { position: "left", type: "linear", stacked: false },
    ],
    []
  );

  const handleOpenMail = () => {
    window.open('mailto:internal@interbrucke.com?cc=daniel@interbrucke.com&subject=Pertanyaan%20web%report.interbrucke.com');
  }
  // const [user] = useAuthState(auth);
  return (
    <div className="main-content">
      <Grid fluid>
        <Row>
          <Col lg={12}>
            <h4 style={{ margin: "0px" }}>
              Selamat datang di web internal PT Interbrucke Perkasa
            </h4>
            <h5 style={{ marginTop: "0px" }}>
              Jika ada pertanyaan, silahkan email ke <label onClick={()=>handleOpenMail()}style={{cursor:"pointer",textDecoration:"underline"}}>internal@interbrucke.com</label>
            </h5>
          </Col>
        </Row>
        
      </Grid>
    </div>
  );
}

export default PengirimanDashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/PengirimanDashboard.jsx